import { render } from "./FormGroup.vue?vue&type=template&id=c1b0fe0a&bindings={\"validator\":\"props\",\"name\":\"props\",\"id\":\"props\",\"help\":\"props\",\"label\":\"props\",\"validationPath\":\"props\",\"$vl\":\"options\",\"field\":\"options\",\"error\":\"options\",\"errorMessage\":\"options\"}"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"
script.render = render

export default script